import React, { Component } from 'react';
import './Common.css';
import './SummaryCard.css';

class SummaryCard extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
        this.convertEthToUsd = this.convertEthToUsd.bind(this);
    }

    handleClick(event) {
        this.props.onClick(event);
    }

    convertEthToUsd(value) {

        let ethPrice = this.props.ethPrice;
  
        let usdStr = "";
        if(value !== "" && value !== null && /^[0-9]+\.?[0-9]*?$/i.test(value) && ethPrice && ethPrice.hasOwnProperty("USD")) {
  
          let usdPerEth = ethPrice.USD;
          let usdFloat = parseFloat(value) * usdPerEth;
  
          if(!isNaN(usdFloat)) {
            usdStr = "($" + usdFloat.toLocaleString('en', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " USD)";
          }
        }
        
        return usdStr;
    }

    render() {  

        let disabled = this.props.disabled || false;

        if(this.props.entry && this.props.entry.hasOwnProperty("common") && this.props.entry.hasOwnProperty("version")) {
            let common = this.props.entry.common;
            let participant1 = common.participant1;
            let participant2 = common.participant2;
            let arbiter = common.arbiter;

            let versionCount = 1;
            if(common.hasOwnProperty("versionCount")) {
                versionCount = common.versionCount;
            }

            let versionNum = versionCount;
            if(common.hasOwnProperty("agreedVersionNum")) {
                versionNum = common.agreedVersionNum;
            }

            let version = this.props.entry.version;
            let status = version.status;
            //let proposedBy = version.proposedBy;
            let betText = version.text;

            let statusArr = [];

            let hasRejected = false;
            for(let i=0; i<statusArr.length; i++) {
                if(statusArr[i] === "REJECTED") {
                    hasRejected = true;
                }
            }

            let participantMessage = "";
            if(this.props.username === participant1) {
                participantMessage = "VS @" + participant2;
                statusArr.push(status[participant1]);
                statusArr.push(status[participant2]);
                statusArr.push(status[arbiter]);    
            }
            else if(this.props.username === participant2) {
                participantMessage = "VS @" + participant1;
                statusArr.push(status[participant2]);
                statusArr.push(status[participant1]);
                statusArr.push(status[arbiter]);    
            }
            else if(this.props.username === arbiter) {
                participantMessage = "@" + participant1 + " VS @" + participant2;
                statusArr.push(status[arbiter]);    
                statusArr.push(status[participant1]);
                statusArr.push(status[participant2]);
            }
            else {
                participantMessage = "@" + participant1 + " VS @" + participant2;
                statusArr.push(status[participant1]);
                statusArr.push(status[participant2]);
                statusArr.push(status[arbiter]);
            }

            let waitingForUser = false;
            if(status[this.props.username] === "NO_RESPONSE" && hasRejected === false) {
                waitingForUser = true;
            }

            let combinedStatus = this.props.combinedStatus;
            let stage = "Proposed";
            if(combinedStatus) {
                stage = combinedStatus.betStatusMsg;
            }
            
            let totalAmount = version.amount1 + version.amount2;

            let { arbitrationRequestDate=""} = version;

            return (
                <div>
                    <div className={"dialogTable" + (disabled ? " dialogTableDiabled" : "")} onClick={this.handleClick}>
                        <div className="cardRow"><span className="strongText padTop20">{participantMessage}</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">{stage}{statusArr.map((value, index) => {
                            if(value === "ACCEPTED") {
                                return (<span key={index} className="squareAccepted"></span>);
                            }
                            else if(value === "REJECTED") {
                                return (<span key={index} className="squareRejected"></span>);
                            }
                            else {
                                return (<span key={index} className="squareAwaiting"></span>);
                            }

                        })} &middot; {totalAmount.toString()} ETH {this.convertEthToUsd(totalAmount)}{versionNum && (<span> &middot; Version {versionNum}</span>)}{false && arbitrationRequestDate !== "" && (<span> &middot; {arbitrationRequestDate}</span>)}</span></div>
                        <div className="cardRow">{betText}{/*JSON.stringify(this.props.entry)*/}</div>
                        {waitingForUser && (<div className="cardRow red">Waiting on your response</div>)}                        
                    </div>
                    <div className="summaryGap"></div>                
                </div>
            );
    
        }

        return null;
    }
  }
  
  export default SummaryCard;


// WEBPACK FOOTER //
// ./src/components/SummaryCard.js